export default "__VITE_ASSET__B9XSd_ra__"